import moment from "moment"

export const calculateHighlighter = (date, scaleX, scaleY, minX, maxX, minY, maxY) => {
  if (!date) {
    return null
  }

  const highlightedDate = moment(date)
  const minDate = moment(minX)
  const maxDate = moment(maxX)

  if (highlightedDate.isBetween(minDate, maxDate, undefined, "[)")) {
    const x = scaleX(highlightedDate.toDate())
    return {
      x1: x,
      x2: x,
      y1: scaleY(minY) + 15, // Makes the highlighter overflow of 15px below the chart.
      y2: scaleY(maxY) - 15, // Makes the highlighter overflow of 15px above the chart.
    }
  } else {
    return null
  }
}
